<template>
  <main>
    <article class="row">
      <section class="col s4" v-if="$auth.hasRoles('admin', 'vote-admin')">
        <aside class="switch" style="margin-top: 25px;">
          <label class="teal-text">
            Individual
            <input type="checkbox" @click="toggle = toggle === 'votes' ? 'stats' : 'votes'">
            <span class="lever" />
            Stats
          </label>
        </aside>
      </section>
      <section class="col s4" v-else />
      <section class="col s4">
        <h4>
          <strong>Best Buys Now</strong>
        </h4>
      </section>
      <section class="col s4" />
    </article>
    <form class="row">
      <section class="input-field col s6" :class="{'yellow accent-1': !portfolioId}">
        <select id="bbn-select-portfolio" v-model="portfolioId">
          <option :value="0" disabled selected>Choose a Portfolio</option>
          <option :value="149">Rule Breakers (BBN)</option>
          <option :value="148">Stock Advisor Tom (BBN)</option>
          <option :value="147">Stock Advisor David (BBN)</option>
        </select>
        <label class="active" for="bbn-select-portfolio">Portfolio</label>
      </section>
      <section class="input-field col s6">
        <select id="bbn-select-edition" v-model="edition">
          <option v-for="edtn of editions" :key="edtn.toDateString()"
                  :value="`${String(edtn.getMonth() + 1).padStart(2, 0)}-01-${edtn.getFullYear()}`"
          >
            {{ edtn.toDateString().slice(4, 7) }} {{ edtn.getFullYear() }}
          </option>
        </select>
        <label class="active" for="bbn-select-edition">Edition</label>
      </section>
    </form>
    <bbn-votes :portfolio-id="portfolioId" :edition="edition" v-if="portfolioId && toggle === 'votes'" />
    <bbn-stats :portfolio-id="portfolioId" :edition="edition" v-if="portfolioId && toggle === 'stats'" />
  </main>
</template>

<script>
import axios from 'axios';
import BestBuysNowVotes from '@/components/BestBuysNowVotes.vue';
import BestBuysNowStats from '@/components/BestBuysNowStats.vue';

export default {
  name: 'BestBuysNow',
  components: {
    BbnVotes: BestBuysNowVotes,
    BbnStats: BestBuysNowStats,
  },
  props: {},
  data() {
    return {
      portfolioId: 0,
      edition: `${String(new Date().getMonth() + 1).padStart(2, 0)}-01-${new Date().getFullYear()}`,
      toggle: 'votes',
    };
  },
  computed: {
    editions() {
      const res = [];
      for (let i = new Date().getMonth() - 12; i <= new Date().getMonth() + 2; i += 1) {
        const result = this.rotateMonth(i, 1, new Date().getFullYear());
        res.push(result);
      }
      return res.reverse();
    },
  },
  methods: {
    initSelect() {
      this.materialize.FormSelect.init(document.querySelectorAll('select'), {
        classes: '',
      });
    },
    rotateMonth(month, day, year) {
      if (month > 12) {
        month -= 12;
        year += 1;
      } else if (month < 1) {
        month += 12;
        year -= 1;
      }
      return new Date(`${month}/${day}/${year}`);
    },
  },
  mounted() {
    this.initSelect();
  },
};
</script>
